// extracted by mini-css-extract-plugin
export default {"data_protection_section":"style_data_protection_section__-IqAw","headline_1":"style_headline_1__7pZv0","content_block":"style_content_block__Te6dq"};